
<div
	class="flow-tab"
	:tabindex="tabindex"
	:type="type"
	:selected="selected"
	:style="tabStyle"
	@click="handleClick($event)"
>
	<!-- @slot Contains Tab content <br/> E.g. Icon , p , h4 ... -->
	<slot />
</div>
